<template>
  <div class="bottom-switch">
    <!--切换一开始-->
    <div class="bottom-content clearfix swiper-container"
         :class="['bottom-content'+blockData.sno]">
      <div class="l-media-info fl swiper-wrapper"
           v-if="listData&&listData.length">
        <div class="img-info swiper-slide"
             @click="$emit('emitHandleDetail',item)"
             @contextmenu="listData?$emit('emitContextMenuItem',ind,$event):''"
             @touchstart="touchstarts(ind)"
             @touchmove="touchmoves()"
             @touchend="touchends()"
             :key="ind"
             v-for="(item,ind) in listData"
             v-show="ind == 0||(['banner','companyIntroduce'].indexOf(centerStyle)>-1)">
          <a href="javascript:;">
            <div class="img">
              <!-- <img :src="item.pictures[0]?item.pictures[0]:require('../../assets/image/images/default_media.jpg')"> -->
              <ZImage :value="item.pictures[0]?item.pictures[0]:''"
                      :error-src="require('../../assets/image/images/default_media.png')" />
            </div>
            <div class="text"
                 v-if="item.others[0]">
              <div class="tit">
                {{item.others[0].standardData?(allPrice(item.others[0].standardEnName) ? formatPrice(item.others[0].standardData) : item.others[0].standardData):''}}
              </div>
              <div class="con"
                   v-if="item.others[1]">
                {{item.others[1].standardData?(allPrice(item.others[1].standardEnName) ? formatPrice(item.others[1].standardData) : item.others[1].standardData):''}}
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="r-media-info fl">
        <div class="item-info-box clearfix"
             v-if="listData.length">
          <div v-for="(item,ind) in listData"
               v-show="ind > 0 && ind<=4"
               @click="$emit('emitHandleDetail',item)"
               @contextmenu="listData?$emit('emitContextMenuItem',ind,$event):''"
               @touchstart="touchstarts(ind)"
               @touchmove="touchmoves()"
               @touchend="touchends()"
               :key="ind"
               class="item-info fl">
            <a href="javascript:;"
               v-if="item.others">
              <div class="tit"
                   v-if="item.others.length">
                {{item.others[0]?(allPrice(item.others[0].standardEnName) ? formatPrice(item.others[0].standardData) : item.others[0].standardData):''}}
              </div>
              <div class="text"
                   v-if="item.others.length">
                {{item.others[1]?(allPrice(item.others[1].standardEnName) ? formatPrice(item.others[1].standardData) : item.others[1].standardData):''}}
              </div>
              <div class="text"
                   v-if="item.others.length">
                {{item.others[2]?(allPrice(item.others[2].standardEnName) ? formatPrice(item.others[2].standardData) : item.others[2].standardData):''}}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--切换一结束-->
  </div>
</template>
    <script>
import ZImage from "../ZImage.vue"
export default {
  name: 'tradeNews',
  components: {
    ZImage
  },
  props: {
    blockData: {
      type: Object
    },
    centerStyle: {
      require: true,
      default: "tradeNews"
    },
    listData: {
      type: Array
    }
  },
  data () {
    return {
      timeOutEvent: 0
    }
  },
  methods: {
    touchstarts (ind) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ind);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
  }
}
    </script>
    
    <style scoped>
.right-content {
  border: 1px solid#ddd;
  overflow: hidden;
}
/*107行业传媒 开始*/
.bottom-switch {
  padding: 18px;
}
.bottom-content {
  height: 288px;
}
.bottom-content .l-media-info {
  width: 428px;
  margin-right: 16px;
}
.bottom-content .l-media-info .img-info {
  position: relative;
}
.bottom-content .l-media-info .img-info a {
  display: block;
}
.bottom-content .l-media-info .img-info a:hover .img img {
  transform: scale(1.1);
}
.bottom-content .l-media-info .img-info .img {
  width: 428px;
  height: 288px;
  overflow: hidden;
}
.bottom-content .l-media-info .img-info .img img {
  width: 428px;
  height: 288px;
  transition: all 0.3s;
}
.bottom-content .l-media-info .img-info .text {
  height: 44px;
  width: 408px;
  background: rgba(0, 0, 0, 0.66);
  line-height: 44px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
}
.companyIntroduce .bottom-content .l-media-info .img-info .text .con {
  display: none;
}
.bottom-content .r-media-info {
  height: 288px;
  width: -webkit-calc(100% - 444px);
  width: -moz-calc(100% - 444px);
  width: calc(100% - 444px);
  position: relative;
}
.bottom-content .r-media-info:before {
  content: "";
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  height: 1px;
  border-top: 1px dashed #ddd;
}
.bottom-content .r-media-info:after {
  content: "";
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  border-left: 1px dashed #ddd;
}
.bottom-content .r-media-info .item-info-box {
  height: 144px;
}
.bottom-content .r-media-info .item-info-box .item-info {
  padding: 10px;
  height: 144px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
}
.bottom-content .r-media-info .item-info-box .item-info a {
  display: block;
  height: 124px;
}
.bottom-content .r-media-info .item-info-box .item-info .tit {
  height: 40px;
  line-height: 22px;
  font-size: 16px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;
}
.bottom-content .r-media-info .item-info-box .item-info .text {
  height: 37px;
  line-height: 18px;
  font-size: 12px;
  color: #666;
  padding-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;
}
.bottom-content .r-media-info .item-info-box .item-info .time {
  padding-top: 10px;
  color: #666;
}
.bottom-content .r-media-info .item-info-box .item-info .other-info {
  height: 18px;
  color: #666;
  padding-top: 10px;
}
.bottom-content .r-media-info .item-info-box .item-info .other-info .time {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #666;
  padding-right: 16px;
}
.bottom-content .r-media-info .item-info-box .item-info .other-info .company {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #666;
  width: 150px;
  text-align: left;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bottom-content .r-media-info .item-info-box .item-info:hover .tit {
  color: #2f8eed;
}
.bottom-content .r-media-info .item-info-box .item-line {
  border-left: 1px dashed #ddd;
  height: 144px;
  margin: 0 16px;
}
.bottom-content .r-media-info .line {
  height: 1px;
  border-top: 1px dashed #ddd;
}
/*107行业传媒 结束*/

/* 企业简介 banner样式 */

.companyIntroduce .l-media-info {
  height: 288px;
  width: 100%;
}
.companyIntroduce .bottom-content .l-media-info .img-info {
  float: left;
  margin-right: 20px;
}
.companyIntroduce .bottom-content .l-media-info .img-info .img {
  float: left;
  width: 50%;
}
.companyIntroduce .bottom-content .l-media-info .img-info .text {
  text-align: left;
  color: #333;
  width: calc(50% - 40px);
  background: #fff;
  float: left;
  position: static;
  padding: 0 20px;
}
.companyIntroduce .bottom-content .l-media-info .img-info .text .tit {
  font-size: 20px;
  line-height: 48px;
  color: #333;
}
.companyIntroduce .bottom-content .l-media-info .img-info .text .con {
  display: block;
  font-size: 14px;
  color: #666;
}
.companyIntroduce .bottom-content .r-media-info {
  display: none;
}
.companyIntroduce .bottom-content .l-media-info .img-info .text {
  height: 288px;
  text-overflow: inherit;
  white-space: inherit;
  line-height: 24px;
}

.banner .l-media-info {
  height: 288px;
  width: 100%;
}
.banner .bottom-content .l-media-info .img-info {
  float: left;
  margin-right: 20px;
  height: 100%;
  width: 100%;
}
.banner .bottom-content .l-media-info .img-info .img {
  float: left;
  width: 100%;
}
.banner .bottom-content .l-media-info .img-info .img img {
  width: 100%;
}
.banner .bottom-content .l-media-info .img-info .text {
  display: none;
}
.banner .bottom-content .r-media-info {
  display: none;
}
.banner .bottom-content .l-media-info .img-info .text {
  height: 288px;
  text-overflow: inherit;
  white-space: inherit;
  line-height: 24px;
}

/* 超小屏幕（手机，小于 768px） */
@media screen   and (max-width: 768px) {
  .right-content .bottom-switch,
  .bottom-content {
    height: auto;
  }
  .bottom-content .l-media-info .img-info .text {
    padding: 0;
  }
  .bottom-content .l-media-info .img-info .text,
  .bottom-content .l-media-info .img-info .img img,
  .bottom-content .l-media-info .img-info .img,
  .bottom-content .l-media-info .img-info,
  .bottom-content .l-media-info,
  .bottom-content .r-media-info {
    width: 100%;
  }
  .bottom-content .r-media-info:after {
    left: 50%;
  }
  .bottom-content .r-media-info {
    margin-top: 15px;
  }
  .bottom-content .l-media-info .img-info .text,
  .bottom-content .r-media-info .item-info-box .item-info .tit {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }

  .content-left-box,
  .content-right-box {
    width: 150px;
    position: absolute;
    top: 0px;
    bottom: 0px;
    z-index: 9;
    background: #fff;
    border-left: 1px solid #dddddd;
    border-right: 1px solid #dddddd;
    height: auto;
  }
  .content-left-box {
    left: 0;
  }
  .content-right-box {
    right: -1px;
  }
  .block-content {
    position: relative;
  }
  .btn-left,
  .btn-right {
    position: absolute;
    top: 160px;
    width: 30px;
    height: 30px;
    border-radius: 20px;
    z-index: 8;
    background-size: contain;
  }
  .btn-left {
    left: 2px;
    background-image: url("~@/assets/image/images/icons/arrow_right_circular.png");
  }
  .btn-right {
    right: 2px;
    background-image: url("~@/assets/image/images/icons/arrow_left_circular.png");
  }
  .close-left,
  .close-right {
    position: absolute;
    top: 10px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    z-index: 10;
    background-size: contain;
    background-image: url("~@/assets/image/images/icons/close_right_top.png");
  }
  .close-left {
    left: 120px;
  }
  .close-right {
    right: 120px;
  }
}
</style>
    
    


// WEBPACK FOOTER //
// src/components/floorBlock/tradeNews.vue